/**
 * IDI-487 (D5, D6): which Review & Send files follow the quote into the
 * downloaded PDF.
 *
 * The backend appends a PDF's pages and a page per PNG or JPEG; any other
 * type can't be included (Review & Send says so beside the file). The quotes
 * list and the quote page carry the latest send's ticked files
 * (quote.sendComposer.included_attachments), else none.
 */

const IMAGE_TYPES = new Set(['image/png', 'image/jpeg', 'image/jpg']);

/** True when the file can be added to the downloaded PDF. */
export function canIncludeInPdf(file) {
  const ct = String(file?.contentType || file?.content_type || file?.type || '').toLowerCase().split(';')[0].trim();
  const name = String(file?.filename || file?.name || '').toLowerCase();
  if (ct === 'application/pdf' || IMAGE_TYPES.has(ct)) return true;
  if (!ct || ct === 'application/octet-stream') {
    return /\.(pdf|png|jpe?g)$/.test(name);
  }
  return false;
}

/**
 * IDI-758 (D1): a stored file list is the dealer's choice only when the send
 * was composed at or after this instant. Before it, Review & Send stored every
 * file as ticked whatever the dealer did, so an older (or absent, or
 * unreadable) stamp means nothing was chosen.
 */
export const CHOICE_CUTOFF = '2026-11-01T01:53:00Z';
const CHOICE_CUTOFF_MS = Date.parse(CHOICE_CUTOFF);

/** The stored ticked files when they are the dealer's choice, else null. */
export function storedChoice(sendComposer) {
  const list = sendComposer?.included_attachments;
  if (!Array.isArray(list)) return null;
  const at = Date.parse(sendComposer?.composed_at ?? sendComposer?.composedAt);
  if (!Number.isFinite(at) || at < CHOICE_CUTOFF_MS) return null;
  return list;
}

/** The latest send's ticked files, else []. */
export function lastSendAttachments(quote) {
  const sc = quote?.sendComposer || quote?.send_composer;
  const list = storedChoice(sc) || [];
  return list.filter((a) => a && (a.attachmentId || a.attachment_id));
}

/** The backend's refusal ('Couldn't add "<file>" to the PDF. …'), if any. */
export function pdfRefusalMessage(err) {
  const msg = err?.response?.data?.message;
  return typeof msg === 'string' && msg.startsWith("Couldn't add ") ? msg : '';
}
